import { RxCollection } from 'rxdb';
import { LoggingModel } from './logging.model';

export interface LoggingDatabaseContext {
	logs: RxCollection<LoggingModel>;
}
